import { AxiosResponse } from 'axios';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { awBffApi } from './Base';

export async function getBffVersion(): Promise<AxiosResponse<string>> {
  const path = '/version';
  const response = await awBffApi.get<AGraphWrappedType<string, 'version'>>(path);
  return unwrapAGraphResponse(response, 'version');
}
